import { fetchApi } from '../api/digitalVault';
import fileCreate from './fileCreate';
import { parseUserResponse } from '../utils';
const MAX_DELAY = 16; // approx 16 seconds.
const MAX_ATTEMPTS = 10; // approx 2 minutes.
// wait for a duration
const duration = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
};
// create a backoff function
const exponentialBackoff = (multiplier = 1) => {
    return (maxBackoff, attempt) => {
        const backoff = Math.min(2 ** attempt, maxBackoff) * Math.abs(multiplier);
        const random = Math.floor(Math.random() * multiplier);
        return backoff + random;
    };
};
// set maximum delay in milliseconds
const backoff = exponentialBackoff(1000);
// poll a job id with exponential backoff
const pollJob = async (jobUid, props, attempt = 0, uploadConfig) => {
    const res = await fetchApi({
        uid: props.uid,
    }, `job`);
    const pollConfig = uploadConfig
        ? uploadConfig
        : {
            maxPollAttempts: MAX_ATTEMPTS,
            maxPollDelay: MAX_DELAY,
        };
    // create file success
    if (res.job?.status?.$ === 'success') {
        return parseUserResponse(undefined, res.job.result.files, () => false);
    }
    // throw error in case of failure
    if (res.job?.error?.error['@code'] || res.job?.status?.$ === 'error') {
        throw new Error(`error: ${jobUid} failed`);
    }
    // throw error if attempt exceeds MAX_ATTEMPTS
    if (attempt > pollConfig.maxPollAttempts) {
        throw new Error(`error: ${jobUid} failed, max attempts exceeded`);
    }
    // wait for backoff duration
    await duration(backoff(pollConfig.maxPollDelay, attempt));
    // repoll jobId
    return pollJob(jobUid, props, attempt + 1, uploadConfig);
};
export default async (...args) => {
    const asyncFileCreateResponse = await fileCreate(...args);
    // if response is a job, poll job for completion else return response
    if ('job' in asyncFileCreateResponse) {
        return pollJob(asyncFileCreateResponse.job.uid?.$, {
            uid: asyncFileCreateResponse.job.uid?.$,
        }, 0, args[9]);
    }
    else {
        return asyncFileCreateResponse;
    }
};
